import { apiCall } from './generated/gqlClient';

const getCalendarEventsApiRequest = async (startTime, endTime, resourceId) => {
  const query = `
    query getCalendarEvents($startTime: DateTime, $endTime: DateTime, $resourceId: Int) {
      getCalendarEvents(startTime: $startTime, endTime: $endTime, resourceId: $resourceId) {
        id
        subscriptionId
        userId
        providerId
        serviceId
        name
        description
        email
        displayName
        startTime
        endTime
        type
        entityType
        status
        serviceName
        preparationTime
        timezone
        user {
          id
          name
          firstname
          lastname
          email
          phone
          timezone
        }
        userInfo {
          firstname
          lastname
          email
          phone
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        duration
        capacity
        totalCapacity
        minimumCapacity
        classId
        subServiceId
        color
        pricingModel
        price
        resources {
          id
          name
          userId
        }
        materialResource {
          id
          name
        }
        location {
          note
          latitude
          longitude
          address
          addressUrl
          url
        }
        note
        presence
        orderId
        clients {
          subscriptionId
          reservationId
          userId
          customerId
          email
        }
      }
    }
  `;
  return apiCall({ query, variables: { startTime, endTime, resourceId } });
};

const getCustomerEventsApiRequest = (identifier, startTime, endTime, customerId, isDeal, sortLatest) => {
  const query = `
    query getCustomerEvents($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {
      getCustomerEvents(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest) {
        id
        customerId
        name
        firstname
        lastname
        email
        phone
        address
        city
        postcode
        country
        birthday
        gender
        describedName
        note
        metadata
        codiceFiscale
        piva
        sdi
        svcGroupId
        timezone
        bookedEvents {
          id
          subscriptionId
          userId
          providerId
          serviceId
          name
          description
          email
          startTime
          endTime
          type
          entityType
          status
          cancelledBy
          duration
          capacity
          totalCapacity
          classId
          subServiceId
          color
          pricingModel
          price
          paidWithUserMembershipId
          paid
          payment
          orderId
          cancelledCounted
          reimbursed
        }
      }
    }
  `;

  return apiCall({ query, variables: { identifier, startTime, endTime, customerId, isDeal, sortLatest } });
};

const getCustomerEventsForWebDealApiRequest = (identifier, startTime, endTime, customerId, isDeal, sortLatest) => {
  const query = `
    query getCustomerEventsForWebDeal($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {
      getCustomerEventsForWebDeal(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest) {
        id
        customerId
        name
        firstname
        lastname
        email
        phone
        address
        city
        postcode
        country
        birthday
        gender
        describedName
        note
        metadata
        codiceFiscale
        piva
        sdi
        svcGroupId
        timezone
        bookedEvents {
          id
          subscriptionId
          userId
          providerId
          serviceId
          name
          description
          email
          startTime
          endTime
          type
          entityType
          status
          cancelledBy
          duration
          capacity
          totalCapacity
          classId
          subServiceId
          color
          pricingModel
          price
          paidWithUserMembershipId
          paid
          payment
          orderId
        }
      }
    }
  `;

  return apiCall({ query, variables: { identifier, startTime, endTime, customerId, isDeal, sortLatest } });
};

export { getCalendarEventsApiRequest, getCustomerEventsApiRequest, getCustomerEventsForWebDealApiRequest };
